import { RWA_COLORS } from "~/styles/colors";

// // // //

/**
 * getRandomColor
 * Gets a random chart color
 * Used when a chart element doesn't have a color assigned by the API
 */
export function getRandomColor(): string {
    const arr = Object.values(RWA_COLORS.chart);

    // Check if the array is empty
    if (arr.length === 0) {
        return "#999999";
    }

    // Generate a random index within the array length
    const randomIndex = Math.floor(Math.random() * arr.length);

    // Return the random element
    return arr[randomIndex];
}
